import React, { Fragment } from 'react'
import { Icon } from 'semantic-ui-react';
import { Constants } from "../../../config/appConstants";

export const TimeCardWeekStatus = (intStatus) => {
    intStatus = intStatus?.toLowerCase() ?? "";
    const status = [Constants.NEW_STATUS, Constants.PROCESSED_STATUS, Constants.EXPORTED_STATUS].map(a => a.toLowerCase());

    return (
        <Fragment>
            {status.includes(intStatus)
                ?
                <Icon style={{ color: "green" }} name="check"></Icon>
                :
                <Icon name="hourglass outline"></Icon>
            }
        </Fragment>
    )
}

export const TimeCardStatus = (intStatus) => {
    intStatus = intStatus?.toLowerCase() ?? "";
    const status = [Constants.PROCESSED_STATUS, Constants.EXPORTED_STATUS].map(a => a.toLowerCase());

    return (
        <Fragment>
            {status.includes(intStatus)
                ?
                <Icon style={{ color: "green" }} name="check"></Icon>
                :
                <Icon name="hourglass outline"></Icon>
            }
        </Fragment>
    )
}